import { render, staticRenderFns } from "./StrdN_Items.vue?vue&type=template&id=07f6a3ab"
import script from "./StrdN_Items.vue?vue&type=script&lang=js"
export * from "./StrdN_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports